import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'CustomPriceRangeLazy',
        path: () => path.join(__dirname, './CustomPriceRange'),
        resolve: () => require.resolveWeak('./CustomPriceRange'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "CustomPriceRangeLazy" */ './CustomPriceRange'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
